import { Helmet } from 'react-helmet';
import { useEffect, useState } from 'react';
import PillTabs from '../components/PillTabs';
import { AUDIENCES, AudiencePanel } from '../sections/WhoWeServeContent';

export default function WhoWeServePage() {
  const [active, setActive] = useState(AUDIENCES[0].id);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const hash = window.location.hash?.replace('#', '');
    if (hash && AUDIENCES.some((audience) => audience.id === hash)) {
      setActive(hash);
    }
  }, []);

  return (
    <main>
      <Helmet>
        <title>Who We Serve | Carter Asset Management</title>
      </Helmet>
      <section className="relative h-screen min-h-[100svh] w-full overflow-hidden">
        <div className="absolute inset-0 h-full w-full">
          <video
            autoPlay
            muted
            loop
            playsInline
            className="absolute left-1/2 top-1/2 h-auto min-h-full min-w-full w-auto -translate-x-1/2 -translate-y-1/2"
          >
            <source src="/images/Video - Helping Hand.mp4" type="video/mp4" />
          </video>
        </div>

        <div className="absolute inset-0 bg-black/30" />

        <div className="relative z-10 max-w-6xl mx-auto h-full flex items-center px-6">
          <div className="max-w-xl text-white">
            <h1 className="text-4xl md:text-5xl font-semibold leading-tight">
              A helping hand whenever you need it.
            </h1>

            <p className="mt-4 text-lg text-white/90">
              Financial decisions do not happen in isolation. Whether you are just getting started,
              supporting a family, planning for retirement, or navigating a career transition,
              our role is to provide thoughtful guidance when it matters most.
            </p>
          </div>
        </div>
      </section>

      <section className="section-container py-10 md:py-20">
        <div>
          <div className="text-center mt-8 mb-6 px-6">
            <p className="text-gray-600 text-lg">
              Choose an option below to see some of the ways our planning can adapt to you.
            </p>
          </div>

          <PillTabs
            tabs={AUDIENCES}
            value={active}
            onChange={setActive}
            ariaLabel="Select audience"
          />

          <AudiencePanel id={active} />
        </div>
      </section>
    </main>
  );
}
